module.exports = __webpack_public_path__ + "assets/GoldXi.4e23893d4cdaaa13bed7d8cf9d1578fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldXi.png
// module id = 778
// module chunks = 0